@if (outcomeWizardForm) {
<div class="edit-outcome-dialog-container" [formGroup]="outcomeWizardForm">
    <div class="hub-modal-header-text">
        <h5>Edit Outcome</h5>
    </div>

    <mat-dialog-content mat-dialog-content class="hub-custom-scrollbar">
        <div class="row">
            <div class="col-md-12">
                <p class="text-center font-weight-bold sb-b p-1">Define your Outcome Statement</p>
                <span class="select-label text-info-800">
                    {{isStrategy ? 'Strategy' : 'Project'}} Outcome Statement
                    <app-help-selector selector="1069"></app-help-selector>
                </span>
                <textarea
                    formControlName="statement"
                    rows="3"
                    cols="3"
                    class="form-control record-description"
                    placeholder="Enter your outcome statement here..."
                ></textarea>

                <div class="hub-validation-error-message">{{getValidationErrorMessages("statement")}}</div>

                @if(!is2030Goals) {
                <div class="calculate-as-rate-panel" formGroupName="customOutcome">
                    <div class="heading">
                        <div class="select-label text-info-800">
                            Calculate as Rate
                            <app-help-selector selector="1213"></app-help-selector>
                        </div>
                    </div>

                    <div class="checkbox-panel">
                        <div class="checkbox-label">
                            <div class="checkbox-label-text">Yes</div>

                            <mat-checkbox color="primary" style="margin-left: 10px" formControlName="isCalculatedAsRate"></mat-checkbox>
                        </div>
                    </div>
                </div>
                }

                <div class="leverage-outcomes-panel">
                    <div class="leverage-outcome-heading">
                        <div class="select-label text-info-800">
                            Leverage Outcome
                            <app-help-selector selector="1204"></app-help-selector>
                        </div>
                    </div>

                    <div class="leverage-outcome-list">
                        <div class="leverage-outcome">
                            <!--If we ever get more than one type of leverage outcome, we will turn this into an ngFor -->
                            <div class="leverage-outcome-name">Policy</div>

                            <mat-checkbox color="primary" style="margin-left: 10px" formControlName="isPolicyLeverageOutcome"></mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions>
        <div class="hub-step-action-buttons">
            <div class="hub-modal-footer-text">
                <button (click)="cancelDialog()" class="cancel-button">Cancel</button>
            </div>

            <button
                type="button"
                class="hub-icon-button SaveButton"
                [disabled]="outcomeWizardForm.invalid"
                (click)="saveProjectOutcome()">
                <b>
                    <i class="icon-floppy-disk"></i>
                </b>
                Done
            </button>
        </div>

    </mat-dialog-actions>
</div>
}
